// extracted by mini-css-extract-plugin
export default {"overlay":"ConfirmDialog_overlay__uimET","modal":"ConfirmDialog_modal__B0YSe","message":"ConfirmDialog_message__w2-JP","cancelBtn":"ConfirmDialog_cancelBtn__x7AUe"};